import { cn } from "@/lib/utils";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

const SwitchSquare = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>>(
    ({ className, checked, onCheckedChange, ...props }, ref) => {
        const [internalChecked, setInternalChecked] = React.useState(false);

        const isControlled = checked !== undefined;
        const isChecked = isControlled ? checked : internalChecked;

        const handleChange = (checked: boolean) => {
            if (!isControlled) {
                setInternalChecked(checked);
            }
            onCheckedChange?.(checked); // Call the external handler if provided
        };

        return (
            <SwitchPrimitives.Root
                className={cn(
                    "peer inline-flex h-7 w-16 shrink-0 cursor-pointer items-center rounded-md border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
                    className
                )}
                {...props}
                ref={ref}
                checked={isChecked}
                onCheckedChange={handleChange}
            >
                <SwitchPrimitives.Thumb
                    className={cn(
                        "pointer-events-none block h-6 w-8 rounded-md bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-0",
                        "flex items-center justify-center"
                    )}
                >
                    <p className={cn(isChecked ? "text-blue-500 " : "text-gray-500", "text-xs font-semibold")}>{isChecked ? "ON" : "OFF"}</p>
                </SwitchPrimitives.Thumb>
            </SwitchPrimitives.Root>
        );
    }
);
SwitchSquare.displayName = SwitchPrimitives.Root.displayName;

export { SwitchSquare };
